import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { User } from 'src/app/models/vos/user.model';
import { URL_GLOBAL } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  isLoggedIn = false;
  token: any;
  constructor(private http: HttpClient, private router: Router) {}
  autenticacao(user: any): Observable<any> {
    return this.http
      .post(`${URL_GLOBAL}/auth/login`, {
        email: user.usuario.trim(),
        password: user.senha.trim(),
      })
      .pipe(
        map((token: any) => {
          if (token.user.pessoa.prestador) {
            this.setTokenLoggedIn(token);
            this.router.navigate(['/main/supplier-reports/create']);
          } else if (
            token.user.pessoa.profissional ||
            token.user.pessoa.responsavel ||
            token.user.pessoa.cliente ||
            true
          ) {
            this.setTokenLoggedIn(token);
            this.router.navigate(['/main/home']);
          } else {
          }
          return token;
        })
      );
  }

  loginByEmail(email) {
    return this.http
      .post(
        `${URL_GLOBAL}/auth/user/login/${email}`,
        {},
        { headers: this.userToken() }
      )
      .pipe(
        map((token: any) => {
          if (token.user.pessoa.prestador) {
            this.setTokenLoggedIn(token);
            window.location.reload();
            this.router.navigate(['/main/supplier-reports/create']);
          } else if (
            token.user.pessoa.profissional ||
            token.user.pessoa.responsavel ||
            token.user.pessoa.cliente ||
            true
          ) {
            this.setTokenLoggedIn(token);
            window.location.reload();
            this.router.navigate(['/main/home']);
          }

          return token;
        })
      );
  }

  userToken() {
    let token = JSON.parse(this.getUserLoggedIn());
    console.log(`============>>>>>>>>>>${token['token_type']}`);
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token['access_token'],
    });
    return headers;
  }

  logout() {
    this.router.navigate(['/auth/login']);

    return this.http
      .get(`${URL_GLOBAL}/auth/logout`, { headers: this.userToken() })
      .subscribe({
        next: (res) => {
          localStorage.removeItem('_token');
          localStorage.clear();
          this.isLoggedIn = false;
        },
        error: (error) => {
          localStorage.removeItem('_token');
          this.isLoggedIn = false;
        },
        complete: () => window.location.reload(),
      });
  }
  setTokenLoggedIn(token: any) {
    localStorage.setItem('_token', `${JSON.stringify(token)}`);
  }
  getUserLoggedIn() {
    return localStorage.getItem('_token');
  }

  getUserName() {
    const { user } = JSON.parse(this.getUserLoggedIn());
    return user.pessoa.nome;
  }

  user() {
    return this.http
      .get<User>(`${URL_GLOBAL}/auth/user`, { headers: this.userToken() })
      .pipe(
        tap((user) => {
          return user;
        })
      );
  }
  updateEmail2(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/users/${id}/updateEmail`, data);
  }
  updateEmail(id: any, data: any): Observable<any> {
    return this.http.put<any>(`${URL_GLOBAL}/attEmail/${id}`, data);
  }
  alterarSenha(token: any, params: any): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: token['token_type'] + ' ' + token['access_token'],
    });
    return this.http.post(`${URL_GLOBAL}/auth/change`, params, { headers });
  }
  esqueceuSenha(params: any): Observable<any> {
    return this.http.post(`${URL_GLOBAL}/auth/reset`, params);
  }
  getAllUsers(): Observable<any[]> {
    return this.http.get<any[]>(`${URL_GLOBAL}/users`);
  }
  getAllUsersAcessos(url: any, params: any): Observable<any[]> {
    return this.http.get<any[]>(
      `${
        url ? url + '&paginate=1' : `${URL_GLOBAL}/getUsers?paginate=1`
      }&name=${params.name ? params.name : ''}&email=${
        params.email ? params.email : ''
      }&cpfcnpj=${params.cpfcnpj ? params.cpfcnpj : ''}`
    );
  }
  usuarioEstaAutenticado() {
    let user = JSON.parse(this.getUserLoggedIn());
    return user ? true : false;
  }
}
